exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.soft-preview[data-v-99a53336] {\n  max-height: calc(100vh - 450px);\n  overflow-y: auto;\n}\n", ""]);

// exports
